export default {
    baseStyle: {
        trendingProducts: {
            padding: [
                '32px 16px',
                '32px 0 32px 32px',
                '32px 0 32px 32px',
                '32px 0 32px 32px',
                '32px 0 32px 64px'
            ],
            backgroundSize: 'cover',
            borderTop: '1px solid rgba(74, 78, 88, 0.30)',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            overflow: 'hidden',
            display: ['block', 'block', 'flex'],
            justifyContent: 'space-between',
            maxWidth: ['100%', '100%', '100%', '100%', '1920px'],
            margin: '0 auto'
        },
        trendingProductsWrapper: {
            alignContent: 'center',
            marginBottom: ['24px', '24px', '0px'],
            width: ['100%', '100%', '368px']
        },
        heading: {
            color: 'white',
            fontSize: ['32px', '32px', '64px'],
            lineHeight: ['normal', 'normal', '72px'],
            paddingBottom: ['16px', '16px', '24px'],
            wordBreak: 'break-word'
        },
        textDescription: {
            paddingBottom: ['16px', '16px', '24px'],
            color: 'white',
            fontSize: ['16px', '16px', '20px'],
            lineHeight: ['24px', '24px', '32px']
        },
        link: {
            fontSize: ['16px', '16px', '20px'],
            lineHeight: ['24px', '24px', '32px']
        },
        linkStyle: {
            borderBottom: '1px solid #ffffff',
            paddingBottom: '5px',
            backgroundPosition: '100% center',
            backgroundRepeat: 'no-repeat',
            paddingRight: '25px'
        },
        scrollerBlock: {
            width: ['100%', '100%', 'calc(100% - 465px)'],
            overflow: 'hidden'
        }
    },
    parts: [
        'trendingProducts',
        'trendingProductsWrapper',
        'heading',
        'textDescription',
        'link',
        'linkStyle',
        'scrollerBlock'
    ]
}
